import axios from "@axios"

const getSettingsEndpoint = '/settings'
const updateSettingsEndpoint = '/settings/update'
const uploadLogoEndpoint = '/settings/upload-logos'
const getPublicSettingsEndpoint = '/settings/public'
const sendTestMailEndpoint = '/settings/testmail'

/**
 * ÍNDICE
 * {@link getSettings} - Obtener configuraciones
 * {@link getPublicSettings} - Obtener configuraciones públicas
 * {@link updateSettings} - Actualizar configuraciones
 * {@link uploadLogos} - Subir logos
 * {@link sendTestMail} - Enviar correo de prueba
 * {@link getCountries} - Obtener paises
 * {@link getProvinces} - Obtener provincias
 */

/**
 * Obtener ajustes de la aplicación
 * @returns settings
 */
export const getSettings = function() {
    try {
        return new Promise((resolve, reject) => {
            axios.post(getSettingsEndpoint)
                 .then(response => { 
                    return resolve(response.data) 
                })
                 .catch(error => { return reject(error) })
        })
    } catch (error) {
        return error
    }
}

/**
 * Obtener los ajustes públicos de la aplicación
 * @returns settings
 */
export const getPublicSettings = function() {
    try {
        return new Promise((resolve, reject) => {
            axios.post(getPublicSettingsEndpoint)
                 .then(response => { return resolve(response.data) })
                 .catch(error => { return reject(error) })
        })
    } catch (error) {
        return error
    }
}

/**
 * Actualizar las configuraciones
 * @param {Settings} data ajustes a modificar 
 * @returns response | error
 */
export const updateSettings = function(data) {
    try {
        return new Promise((resolve, reject) => {
            axios.post(updateSettingsEndpoint, data)
                 .then(response => { return resolve(response.data) })
                 .catch(error => { return reject(error) })
        })
    } catch (error) {
        return error
    }
}

/**
 * Subir logo
 * @param {File} file Archivo a subir
 * @param {string} type [ "square", "full", "favicon" ]
 * @returns 
 */
export const uploadLogos = function(file, type) {
    try {
        let formData = new FormData()
        formData.append('file', file)
        formData.append('type', type)

        let headers = {
            "Content-Type": "multipart/form-data"
        }

        return new Promise((resolve, reject) => {
            axios.post(uploadLogoEndpoint, formData, headers)
                 .then(response => { return resolve(response.data) })
                 .catch(error => { return reject(error) })
        })
    } catch (error) {
        return error
    }
}

/**
 * Enviar email de prueba
 * @param {string} email 
 * @returns response | error
 */
export const sendTestMail = function(email) {
    try {
        return new Promise((resolve, reject) => {
            axios.post(sendTestMailEndpoint, { email })
                 .then(response => { return resolve(response.data) })
                 .catch(error => { return reject(error) })
        })
    } catch (error) {
        return error
    }
}

/**
 * Obtener los paises 
 * @returns countries 
 */
export const getCountries = function() {
    try {
        return new Promise((resolve, reject) => {
            axios.get('countries')
                 .then(response => { return resolve(response.data) })
                 .catch(error => { return reject(error) })
        })
    } catch (error) {
        return error
    }
}

/**
 * Obtener las provincias
 * @returns provinces
 */
export const getProvinces = function() {
    try {
        return new Promise((resolve, reject) => {
            axios.get('provinces')
                 .then(response => { return resolve(response.data) })
                 .catch(error => { return reject(error) })
        })
    } catch (error) {
        return error
    }
}

/**
 * Subir el certificado
 * @returns provinces
 */
export const uploadCert = function (file, password) {
    try {
        let formData = new FormData()
        formData.append('file', file)
        formData.append('password', password)

        let headers = {
            "Content-Type": "multipart/form-data"
        }

        return new Promise((resolve, reject) => {
            axios.post('/settings/upload-cert', formData, headers)
                 .then(response => { console.log(response); return resolve(response.data) })
                 .catch(error => {console.log(error); return reject(error) })
        })
    } catch (error) {
        return error
    }
}